import axios from "axios";

export default function sendRequisiteVerify(list) {
  return axios.put("/wallet/requisite/verify", {
    list,
  });
}
